import graphql__b6030015e0a0618107bc from "./__generated__/UpdateTeamContactDialogProps_contact.graphql.ts";
import graphql__c050e334e89afeea09a4 from "./__generated__/UpdateTeamContactDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type UpdateTeamContactDialogProps = {
    queryRef: any
    handleCloseDialog: () => {}
}

const UpdateTeamContactDialog: React.FC<UpdateTeamContactDialogProps> = (props) => {
    const intl = useIntl();
    const contact = useFragment(
        graphql__b6030015e0a0618107bc,
        props.queryRef
    )

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();
    
    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__c050e334e89afeea09a4,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToUpdateTeamContact'})
            }
        )
    }

    const initialValues = {
        id: contact.id,
        teamName: contact.teamName,
        emailAddress: contact.emailAddress,
        phoneNumber: contact.phoneNumber ?? undefined
    }

    const validationSchema = yup.object().shape({
        teamName: yup.string()
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .matches(/^[\w,\-+&!?/ ()*.\\'äàáâæãåāéèêëėîïíīìöôòóõœøōüûùúūßśšñńçćčÿÄÀÁÂÆÃÅĀÉÈÊËĖÎÏÍĪÌÖÔÒÓÕŒØŌÜÛÙÚŪSSŚŠÑŃÇĆČŸ]{2,255}$/u, intl.formatMessage({id: 'validation.field.nameContainsInvalidCharacters'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        emailAddress: yup.string()
            .max(255, intl.formatMessage({id: 'validation.field.emailAddressTooLong'}))
            .email(intl.formatMessage({id: 'validation.field.emailAddressInvalid'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        phoneNumber: yup.string() // The ITU E.164 states that phone numbers around the globe are recommended to not be longer than 15 digits, but we allow more digits to be safe
            .max(20, intl.formatMessage({id: 'validation.field.phoneNumberTooLong'}))
            .matches(/^(\+(?:[0-9] ?){6,19}[0-9])?$/, intl.formatMessage({id: 'validation.field.phoneNumberInvalid'}))
            .nullable()
    });

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.UpdateTeamContactDialog.headline'})} submitLabel={intl.formatMessage({id: 'dialog.UpdateTeamContactDialog.submitLabel'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.teamName'})}</Label>
                    <Field name="teamName" type="text" placeholder={intl.formatMessage({id: 'dialog.CreateTeamContactDialog.teamNamePlaceholder'})} autoFocus={true}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.emailAddress'})}</Label>
                    <Field name="emailAddress" type="text" placeholder={intl.formatMessage({id: 'dialog.CreateTeamContactDialog.emailPlaceholder'})}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.phoneNumber'})}</Label>
                    <Field name="phoneNumber" type="text" placeholder={intl.formatMessage({id: 'dialog.CreateTeamContactDialog.phonePlaceholder'})}/>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default UpdateTeamContactDialog;
